/* Shared visual primitives used across landing sections. */

export function SectionEyebrow({ children }) {
    return (
        <span className="inline-flex items-center text-[10px] uppercase tracking-[0.3em] px-3 py-1.5 rounded-full border text-[#1FA8FF] border-[#1FA8FF]/30 bg-[#1FA8FF]/10">
            {children}
        </span>
    );
}

export function ModuleCard({ icon: Icon, title, body, flagship }) {
    return (
        <article
            className={`reveal lift rounded-2xl p-6 ${
                flagship
                    ? "bg-[#0A0A0A] text-white border-2 border-[#1FA8FF] relative shadow-[0_8px_30px_rgba(31,168,255,0.15)]"
                    : "bg-[#F8FAFC] border border-zinc-200 text-[#0A0A0A]"
            }`}
            data-testid={flagship ? "module-flagship" : undefined}
        >
            {flagship && (
                <span className="absolute -top-3 left-6 inline-flex items-center text-[10px] uppercase tracking-[0.25em] font-semibold px-2.5 py-1 rounded-full bg-[#1FA8FF] text-white">
                    Flagship
                </span>
            )}
            <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                    flagship
                        ? "bg-[#1FA8FF]/15 text-[#1FA8FF]"
                        : "bg-[#0A0A0A] text-white"
                }`}
            >
                <Icon className="w-5 h-5" />
            </div>
            <h3
                className={`mt-5 font-sora font-semibold text-base leading-tight ${
                    flagship ? "text-white" : "text-[#0A0A0A]"
                }`}
            >
                {title}
            </h3>
            <p
                className={`mt-2.5 text-[14px] leading-relaxed ${
                    flagship ? "text-zinc-300" : "text-zinc-600"
                }`}
            >
                {body}
            </p>
        </article>
    );
}

export function SignatureCard({ stat, kicker, body, title }) {
    return (
        <article className="reveal lift rounded-2xl p-6 bg-gradient-to-br from-[#1FA8FF] via-[#1FA8FF] to-[#0C84D4] text-white border border-[#1FA8FF]/40">
            <div className="font-display text-6xl leading-none">{stat}</div>
            <div className="mt-1 text-[11px] uppercase tracking-[0.25em] opacity-90">
                {kicker}
            </div>
            <h3 className="mt-5 font-sora font-semibold text-base leading-tight">
                {title}
            </h3>
            <p className="mt-2.5 text-[14px] leading-relaxed text-white/85">
                {body}
            </p>
        </article>
    );
}

export function CaseStudy({ title, sector, modules, outcome }) {
    return (
        <article className="reveal lift rounded-2xl border border-zinc-200 bg-white p-6 sm:p-7">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#1FA8FF]">
                Case study
            </div>
            <h3 className="mt-2 font-sora font-semibold text-xl text-[#0A0A0A] leading-tight">
                {title}
            </h3>
            <dl className="mt-5 space-y-2.5 text-sm">
                <DefRow label="Sector" value={sector} />
                <DefRow label="Modules deployed" value={modules} />
            </dl>
            <div className="mt-5 pt-4 border-t border-zinc-200">
                <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                    Outcome
                </div>
                <p className="mt-1.5 text-[15px] text-[#0A0A0A] leading-relaxed">
                    {outcome}
                </p>
            </div>
        </article>
    );
}

function DefRow({ label, value }) {
    return (
        <div className="flex items-baseline gap-3">
            <dt className="text-[11px] uppercase tracking-widest text-zinc-500 w-32 shrink-0">
                {label}
            </dt>
            <dd className="text-[14px] text-[#0A0A0A]">{value}</dd>
        </div>
    );
}

export function SecurityTile({ icon: Icon, title, body }) {
    return (
        <article className="reveal lift rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-6">
            <Icon className="w-7 h-7 text-[#1FA8FF]" />
            <h3 className="mt-5 font-sora font-semibold text-base text-white leading-tight">
                {title}
            </h3>
            <p className="mt-2.5 text-[13.5px] text-zinc-400 leading-relaxed">
                {body}
            </p>
        </article>
    );
}

export function FooterAnchorCol({ title, items, scrollTo }) {
    return (
        <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white mb-4">
                {title}
            </div>
            <ul className="space-y-2.5 text-sm">
                {items.map((it) => (
                    <li key={it.id}>
                        <button
                            onClick={() => scrollTo(it.id)}
                            className="hover:text-white transition-colors text-zinc-400"
                        >
                            {it.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
